import { Stack } from '@mui/material'
import { roundingNumber } from 'components/shared/processes'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface MilkInfoBlockProps {
	yieldMilk: number | string
	description: string
}

const MilkInfoBlock = ({ yieldMilk, description }: MilkInfoBlockProps) => {
	return (
		<Stack direction='column' gap='4px'>
			<TypographySecondary>Итого за период</TypographySecondary>
			<Stack direction='row' gap='4px'>
				{yieldMilk !== null && yieldMilk !== undefined ? (
					<>
						<TypographyPrimary16Bold>
							{roundingNumber(yieldMilk, 1).toLocaleString()}
						</TypographyPrimary16Bold>
						<TypographyPrimary12>л</TypographyPrimary12>
					</>
				) : (
					<TypographySecondary>Нет данных</TypographySecondary>
				)}
			</Stack>
			<TypographySecondary>{description}</TypographySecondary>
		</Stack>
	)
}

export default MilkInfoBlock
